module.exports = __webpack_public_path__ + "static/media/fasting.f404ea25.png";